import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { NamespacedStoreState } from '@Types/store.types';
import { useSelector } from 'react-redux';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const failureDefinitionsStoreSelector = createSelector(parseNamespace, state => state.FailureDefinitionsStore);

export const failureDefinitionsListAllSelector = createSelector(
	failureDefinitionsStoreSelector,
	failureDefinitionsStoreSelector => failureDefinitionsStoreSelector.allFailureDefinitionsList.failureDefinitions,
);

export const selectAllFailureDefinitions = () => useSelector(failureDefinitionsListAllSelector);

export const failureDefinitionSelector = createSelector(
	failureDefinitionsStoreSelector,
	failureDefinitionsStoreSelector => failureDefinitionsStoreSelector.failureDefinition,
);

export const selectFailureDefinition = () => useSelector(failureDefinitionSelector);

export const failureDefinitionsCardsSelector = createSelector(
	failureDefinitionsStoreSelector,
	failureDefinitionsStoreSelector => ({
		failureDefinitions: failureDefinitionsStoreSelector.allFailureDefinitionsList.failureDefinitions,
		isLoading: failureDefinitionsStoreSelector.allFailureDefinitionsList.inProcess,
		successful: failureDefinitionsStoreSelector.allFailureDefinitionsList.successful,
	}),
);

export const selectFailureDefinitionsCards = () => useSelector(failureDefinitionsCardsSelector);

export const failureDefinitionRunResultsSelector = createSelector(
	failureDefinitionsStoreSelector,
	failureDefinitionsStoreSelector => failureDefinitionsStoreSelector.failureDefinitionRunResults,
);

export const selectFailureDefinitionRunResults = () => useSelector(failureDefinitionRunResultsSelector);

export const failureDefinitionPaginationStateSelector = createSelector(
	failureDefinitionsStoreSelector,
	failureDefinitionsStoreSelector => failureDefinitionsStoreSelector.paginationState,
);

export const selectFailureDefinitionPaginationState = () => useSelector(failureDefinitionPaginationStateSelector);

export const selectFailureDefinitionModelPaginationState = (failureDefinitionId: string) =>
	useSelector((state: NamespacedStoreState) => {
		const paginationState = failureDefinitionPaginationStateSelector(state);
		return paginationState[failureDefinitionId] || null;
	});

export const failureDefinitionProcessSelector = createSelector(failureDefinitionsStoreSelector, store => ({
	isUpsertInProcess: store.inProcess,
	isRunInProcess: store.run.inProcess,
}));

export const selectFailureDefinitionProcess = () => useSelector(failureDefinitionProcessSelector);
